import { Redirect, Route } from 'react-router-dom';

import type React from 'react';

type RouteIfProps = {
	condition: boolean;
	path: string;
	render: (props: any) => React.ReactNode;
	redirect: string;
};

export const RouteIf = ({
	condition,
	path,
	render,
	redirect,
}: RouteIfProps) => {
	return condition ? (
		<Route exact path={path} render={render} />
	) : (
		<Redirect to={redirect} />
	);
};
